/*------------------------------------------------
// File Name:PDM_BodyCheck_YuYue.js
// File Description:PDM_BodyCheck_YuYue store方法
// Author:zxl
// Create Time:2023/05/26 18:22:35
//------------------------------------------------*/

import {
    GetPDM_BodyCheck_YuYueList,
    GetPDM_BodyCheck_YuYueListByPage,
    GetPDM_BodyCheck_YuYueEntity,
    CreatePDM_BodyCheck_YuYueEntity,
    UpdatePDM_BodyCheck_YuYueEntity,
    DeletePDM_BodyCheck_YuYueEntity,
} from '@/api/pdm/bodycheckYuyue'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmBodycheckYuyue = {
    namespaced: true,
    state: {
        PdmBodycheckYuyueList: [],
        PdmBodycheckYuyueListLoading: false,
        PdmBodycheckYuyueEntity: null,
        PdmBodycheckYuyueShowDlg: false,
    },
    mutations: {
        setPdmBodycheckYuyueList(state, dataList) {
            state.PdmBodycheckYuyueList = [...dataList]
        },
        setPdmBodycheckYuyueListLoading(state, visible) {
            state.PdmBodycheckYuyueListLoading = visible
        },
        setPdmBodycheckYuyueShowDlg(state, visible) {
            state.PdmBodycheckYuyueShowDlg = visible
        },
        setPdmBodycheckYuyueEntity(state, entity) {
            state.PdmBodycheckYuyueEntity = entity
        },
    },
    actions: {
        //创建对象
        actCreatePdmBodycheckYuyue({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_BodyCheck_YuYueEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckYuyueEntity', res.Data)
                        commit('setPdmBodycheckYuyueShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载对象
        actGetPdmBodycheckYuyueEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckYuyueListLoading', true)
                GetPDM_BodyCheck_YuYueEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckYuyueEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckYuyueListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载列表
        actGetPdmBodycheckYuyueList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckYuyueListLoading', true)
                GetPDM_BodyCheck_YuYueList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckYuyueList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckYuyueListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载列表
        actGetPdmBodycheckYuyueListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckYuyueListLoading', true)
                GetPDM_BodyCheck_YuYueListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckYuyueList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckYuyueListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存信息
        actUpdatePdmBodycheckYuyue({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_BodyCheck_YuYueEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckYuyueShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_YuYue
        actEditPdmBodycheckYuyueData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmBodycheckYuyueID : entity.PdmBodycheckYuyueID
                }
                GetPDM_BodyCheck_YuYueEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmBodycheckYuyueEntity', res.Data)
                        commit('setPdmBodycheckYuyueShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_YuYue ,传对象过来
        actEditPdmBodycheckYuyue({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmBodycheckYuyueEntity', entity)
                commit('setPdmBodycheckYuyueShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_BodyCheck_YuYue
        actDeletePdmBodycheckYuyue({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前？").onOk(() => {
                    DeletePDM_BodyCheck_YuYueEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmBodycheckYuyueShowDlg', false)
                           
                            msg.success("删除成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除失败，原因:" + res.Message)
                            //msg.success("删除失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


